__turbopack_context__.v({
  "base": "button-module-scss-module__rlSILW__base",
  "button": "button-module-scss-module__rlSILW__button",
  "content": "button-module-scss-module__rlSILW__content",
  "custom": "button-module-scss-module__rlSILW__custom",
  "disableHoverGrow": "button-module-scss-module__rlSILW__disableHoverGrow",
  "fill-container": "button-module-scss-module__rlSILW__fill-container",
  "hug-contents": "button-module-scss-module__rlSILW__hug-contents",
  "iconButton": "button-module-scss-module__rlSILW__iconButton",
  "inverse": "button-module-scss-module__rlSILW__inverse",
  "neutral": "button-module-scss-module__rlSILW__neutral",
  "overlay": "button-module-scss-module__rlSILW__overlay",
  "primary": "button-module-scss-module__rlSILW__primary",
  "secondary": "button-module-scss-module__rlSILW__secondary",
  "small": "button-module-scss-module__rlSILW__small",
  "static": "button-module-scss-module__rlSILW__static",
  "subset-sxm-blue": "button-module-scss-module__rlSILW__subset-sxm-blue",
  "tertiary": "button-module-scss-module__rlSILW__tertiary",
  "tertiaryNoPadding": "button-module-scss-module__rlSILW__tertiaryNoPadding",
  "x-small": "button-module-scss-module__rlSILW__x-small",
});
